var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"teacher-mini-card",class:_vm.size},[_c('user-picture',{attrs:{"user":_vm.teacher}}),_vm._v(_vm._s(_vm.teacher.first_name || 'Teacher '+(_vm.index+1)))],1)}
var staticRenderFns = []

export { render, staticRenderFns }